import 'vue-toastification/dist/index.css'

export interface IHost {
  send: Function
  subscribeListener: Function
  unSubscribeListener: Function
}

export default defineNuxtPlugin((nuxtApp) => {
  const send = (message: any) => {
    try {
      // Check if the message is a String or an Object
      if (typeof message !== 'string' && !(message instanceof String)) message = JSON.stringify(message)

      // Ensure that the native context has been established
      if (
        !(window as any).webkit ||
        !(window as any).webkit.messageHandlers ||
        !(window as any).webkit.messageHandlers.hostChannel
      ) {
        throw new Error('Native context not established yet.')
      }

      // Send the specified message to the host
      // NB: `hostChannel` is the name of the Webkit callbackHandler chosen by the team
      ;(window as any).webkit.messageHandlers.hostChannel.postMessage(message)
    } catch (error) {
      console.error('host message error : ', message)
    }
  }
  const subscribeListener = (cb: any) => window.addEventListener('message', cb, false)
  const unSubscribeListener = (cb: any) => window.removeEventListener('message', cb, false)
  const host: IHost = {
    send,
    subscribeListener,
    unSubscribeListener,
  }
  return {
    provide: {
      host,
    },
  }
})
